// extracted by mini-css-extract-plugin
export default {"container":"ProfilePage_container__HAlWm","center":"ProfilePage_center__O7CNU"};